import { render, staticRenderFns } from "./CategoryNavigation.vue?vue&type=template&id=5fe30b2d&scoped=true&"
import script from "./CategoryNavigation.vue?vue&type=script&lang=js&"
export * from "./CategoryNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CategoryNavigation.vue?vue&type=style&index=0&id=5fe30b2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe30b2d",
  null
  
)

export default component.exports